import { getDocument } from '@atlaskit/browser-apis';

/**
 * Drops the fragment without adding a history entry or firing `hashchange`.
 * Visitors still arrive on deep links such as `#about`, so once an affordance
 * has scrolled them back to the top, leaving the fragment in place would have
 * the URL describe a section they are no longer looking at.
 */
export const clearHash = (): void => {
	const view = getDocument()?.defaultView;
	if (!view) {
		return;
	}
	const { pathname, search } = view.location;
	view.history.replaceState(view.history.state, '', `${pathname}${search}`);
};
